import React, { Component } from "react";
import { connect } from "react-redux";
import SchoolDetailTop from "../../../components/School/SchoolDetail/SchoolDetailTop";
import SchoolSubject from "../../../components/School/SchoolDetail/SchoolDetailDown/components/SchoolSubject";
import SchoolConditionView from "../../../components/School/SchoolDetail/SchoolConditionView";
import { get, post } from "../../../utils/request";
import "./style.css";
/**
 * 选科查询院校的详情页面
 */
class SchoolDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      subjectStr: "",
    };
  }
  componentDidMount() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.requestSubjects();
  }
  componentWillMount() {
    this.requestSchoolDetail();
  }
  render() {
    const { subjectStr } = this.state;
    return (
      <div>
        <SchoolDetailTop
          sheetVisible={false}
          data={this.state.data}
        ></SchoolDetailTop>
        <SchoolConditionView condition={subjectStr}></SchoolConditionView>
        <SchoolSubject
          hashId={this.props.match.params.hashId}
          data={this.state.data}
          visible={true}
          type="subject"
        ></SchoolSubject>
        <div style={{ height: 43 }}></div>
      </div>
    );
  }
  /**
   * 请求院校详细信息
   */
  requestSchoolDetail() {
    let hashId = this.props.match.params.hashId;
    get("/public/v1/school/detail/" + hashId).then((res) => {
      this.setState({
        data: res.data,
      });
    });
  }
  /**
   * 请求选科条件详细信息
   */
  requestSubjects() {
    let sessionSubject = JSON.parse(sessionStorage.getItem("suject"));
    let params;
    // 先看看sessionStorage有没有suject的数据，如果没有去redux里面看看
    if (sessionSubject === null) {
      params = { ids: this.props.subject };
    } else {
      params = { ids: sessionSubject };
    }
    post("/public/v1/common/subject", params).then((res) => {
      let subjectStr = "";
      res.data.map((item) => {
        return (subjectStr = subjectStr + item.name + "、");
      });
      this.setState({
        subjectStr: subjectStr.substr(0, subjectStr.length - 1),
      });
    });
  }
}
const mapStateToProps = (state) => {
  return {
    subject: state.subjectquery.subjectData.subject,
  };
};
export default connect(mapStateToProps)(SchoolDetail);



// WEBPACK FOOTER //
// ./src/containers/SubjectQuerySchool/SchoolDetail/index.js